import { Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { PassphraseResponse } from '@models/passphrase/passphrase.model';

@Injectable({
  providedIn: 'root'
})
export class PassphraseService {
  constructor(private httpClient: HttpClient) {}

  post(loader=true): Observable<PassphraseResponse[]> {
    return this.httpClient.post<PassphraseResponse[]>('passphrase', null, {
      params: { loader: loader}
    });
  }
}
